// components/GraficoContainer.tsx
import React, { useState, useRef, useEffect } from "react";
import { AiOutlineReload } from "react-icons/ai";
import { GraficoLinha } from "../GraficoLinha";
import { ErroTabela } from "../../Erros/ErroTabela";
import { LoadingButton } from "../../loadingButtom";

interface GraficoContainerProps {
   loading: boolean;
   erro: boolean;
   titulo: string;
   dados: number[];
   labels: string[];
   indexData: number;
   setIndexData: React.Dispatch<React.SetStateAction<number>>;
   tituloTooltip: string;
   dadoTooltip: string;
   onReload: () => void;
   graficoPorcentagem?: boolean;
}

export const GraficoContainer = ({
   loading,
   erro,
   titulo,
   dados,
   labels,
   indexData,
   setIndexData,
   tituloTooltip,
   dadoTooltip,
   onReload,
   graficoPorcentagem = false,
}: GraficoContainerProps) => {
   return (
      <div className="caixa1">
         <fieldset className="fieldsetGrafico fieldsetGraficoHome">
            {erro ? (
               <ErroTabela
                  handleClick={onReload}
                  className="formatacaoGrafico"
                  titleButton={<AiOutlineReload className="iconButtonDashboard" />}
               />
            ) : !loading ? (
               <div className="divGrafico">
                  <GraficoLinha
                     setIndexData={setIndexData}
                     dadosGrafico={dados}
                     labels={labels}
                     alturaGrafico="350px"
                     nomeDado="Evolução"
                     tituloGrafico={titulo}
                     tituloTooltip={tituloTooltip}
                     dadoTooltip={dadoTooltip}
                     graficoPorcentagem={graficoPorcentagem}
                  />
               </div>
            ) : (
               <LoadingButton />
            )}
         </fieldset>
      </div>
   );
};
